import { Controller } from '@hotwired/stimulus'
class BoardComments extends Controller {
  connect () {
    // NOTE: _comment_form.html.haml で新規作成時・編集時のどちらかでしか
    //       利用されない要素はtargetではなくクラス指定にしている
    this.newCommentForm = this.newCommentTarget.querySelector('.js-comment-editor__form')
    this.newCommentBody = this.newCommentTarget.querySelector('.comment-form__textfield')
  }

  quoteSelectedText (e) {
    if (e.code === 'KeyR') {
      this.addSelectionToCommentBody(e)
    }
  }

  addSelectionToCommentBody (e) {
    const selected = window.getSelection()?.toString() || ''
    if (selected === '' || document.activeElement === this.newCommentBody || !this.newCommentForm.classList.contains('active')) {
      return
    }
    e.preventDefault()
    const insert = `> ${selected}\n\n`
    this.newCommentBody.value = this.newCommentBody.value + insert
    this.newCommentBody.focus()
  }
}
BoardComments.targets = ['newComment']
export default BoardComments
